import React from 'react';
import { PlayerInfoProps } from '@screens/players/types/player.info.props';
import { InfoArea, InfoAreaTitle } from '@screens/players/player.details.tabs/player.info.styles';
import { StatsContainer } from '@screens/players/stats.container';
import { StatRow } from '@screens/players/stat.display';

export const RexDailyBonusInfo = ({ player, info }: PlayerInfoProps) => {
  const dailyBonus = info.detailBonus;

  if (!dailyBonus) return null;

  // level:
  // until 10 bonus 1
  // until 30 bonus 2
  // until 60 bonus 3
  // above 100 bonus 4
  const bonus = [100, 125, 150, 175, 200];

  const { level } = player.inventory;

  let index = 0;

  if (level >= 10 && level < 30) {
    index = 1;
  } else if (level >= 30 && level < 60) {
    index = 2;
  } else if (level >= 60 && level < 100) {
    index = 3;
  } else if (level >= 100) {
    index = 4;
  }
  const currentBonus = bonus[index];

  return (
    <InfoArea>
      <InfoAreaTitle>Daily Bonus</InfoAreaTitle>
      <StatsContainer outlined column expandHeight>
        <StatRow label='Bonus'>({bonus.toString()})</StatRow>
        <StatRow label='Current Bonus'>{currentBonus}</StatRow>
        <StatRow label='Last Collect'>{dailyBonus.lastCollect}</StatRow>
        <StatRow label='Next Collect'>{dailyBonus.nextCollect}</StatRow>
      </StatsContainer>
    </InfoArea>
  );
};
